export default __webpack_public_path__ + "static/media/img-completed-mark@3x.9bf5bfeb.png";